import disfuncaoEretil from '@cannect/assets/img/subcategories/disfuncao-eretil-1.webp'
import doencasCronicas from '@cannect/assets/img/subcategories/doencas-cronicas.webp'
import dorFebre from '@cannect/assets/img/subcategories/dor-febre.webp'
import gripesResfriados from '@cannect/assets/img/subcategories/gripes-resfriados.webp'
import higieneBeleza from '@cannect/assets/img/subcategories/higiene-beleza.webp'
import mamaeEBebe from '@cannect/assets/img/subcategories/mamae-e-bebe.webp'
import perdaDePeso from '@cannect/assets/img/subcategories/perda-de-peso.webp'
import quedaDeCabelo from '@cannect/assets/img/subcategories/queda-de-cabelo.webp'
import saudeMentalBemEstar from '@cannect/assets/img/subcategories/saude-mental-bem-estar.webp'
import vitaminasSuplementos from '@cannect/assets/img/subcategories/vitaminas-suplementos.webp'

/**
 * As nove categorias da farmácia (Figma node 4436:1905). O container do arquivo recorta em sete,
 * e as duas últimas só aparecem ao avançar o carrossel.
 *
 * As chaves são os handles da Pill, não os títulos: é o mesmo conjunto que o
 * `SubcategoryCircles` consome da API (disfuncao-eretil-1, doencas-cronicas, dor-febre,
 * gripes-resfriados, higiene-beleza, mamae-e-bebe, queda-de-cabelo, saude-mental-bem-estar,
 * vitaminas-suplementos). Ver o comentário do componente sobre a unificação pendente.
 *
 * Cada card filtra pela **collection da Pill**, resolvida pelo próprio `handle` — não há mais um
 * campo `query` por item. Antes, seis dos nove iam para a listagem sem filtro nenhum e dois
 * filtravam por `class_id`, que é gerado pelo banco de cada ambiente (16 e 6 aqui, outros números
 * em produção — mesma armadilha do PR #2459). Derivar de `handle` torna impossível um card ficar
 * sem filtro e não depende de id de ambiente: `shopify_collection` casa por `handle`
 * (`productRepository`, include de `shopifyCollections`).
 *
 * Nota sobre os dois que eram `class_id`: a collection é mais restrita que a classe — "Higiene &
 * Beleza" tem 179 produtos Pill contra 2.174 da classe, e "Vitaminas & Suplementos" 56 contra 12
 * dos Nutracêuticos. Como esta seção é a farmácia Pill, a collection é o recorte correto.
 *
 * "Perda de peso" (Asana 1218949691856631) entrou como mais um handle, sem mecanismo novo: a
 * categoria reune produtos Pill com a tag `perda-de-peso` e os produtos Cannect 16034 e 33311, e
 * quem faz essa uniao e o vinculo em `cn_product_shopify_collections` — o front so aponta para o
 * handle, como os demais cards. Se a listagem vier vazia ou so com os itens da Pill, o que falta e
 * o vinculo no banco, nao codigo aqui.
 */
export const PHARMACY_CATEGORIES = [
  { handle: 'perda-de-peso', label: 'Perda de peso', image: perdaDePeso },
  { handle: 'doencas-cronicas', label: 'Doenças Crônicas', image: doencasCronicas },
  { handle: 'mamae-e-bebe', label: 'Mamãe e Bebê', image: mamaeEBebe },
  { handle: 'saude-mental-bem-estar', label: 'Saúde Mental & Bem-Estar', image: saudeMentalBemEstar },
  // { handle: 'higiene-beleza', label: 'Higiene & Beleza', image: higieneBeleza },
  // { handle: 'vitaminas-suplementos', label: 'Vitaminas & Suplementos', image: vitaminasSuplementos },
  { handle: 'queda-de-cabelo', label: 'Queda de Cabelo', image: quedaDeCabelo },
  { handle: 'disfuncao-eretil-1', label: 'Disfunção Erétil', image: disfuncaoEretil },
  { handle: 'gripes-resfriados', label: 'Gripes & Resfriados', image: gripesResfriados },
  { handle: 'dor-febre', label: 'Dor & Febre', image: dorFebre }
]

export const PHARMACY_BASE_PATH = '/produtos/1?limit=16&translated_name='

/** Destino de um card da farmácia: a listagem filtrada pela collection daquele handle. */
export const buildPharmacyCategoryPath = (handle: string) => `${PHARMACY_BASE_PATH}&shopify_collection=${handle}`

/**
 * Os quatro benefícios do rodapé da seção (Figma node 4619:487).
 *
 * A revisão de 2026-07-31 voltou a separar assinatura e descontos, que uma versão anterior tinha
 * fundido num item só, e distribuiu os quatro numa grade 2x2.
 *
 * Um ajuste de copy mantido do arquivo: "receber aonde escolher" vira "onde escolher".
 */
export const PHARMACY_BENEFITS = [
  'Economia com os melhores preços do mercado',
  'Facilidade e conveniência de receber onde escolher',
  'Faça sua assinatura e nunca interrompa seu tratamento',
  'Receba descontos adicionais'
]
